import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CartCtx = createContext(null);
const getCartId = () => {
  let id = localStorage.getItem("bmi_cart_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("bmi_cart_id", id);
  }
  return id;
};

export function CartProvider({ children }) {
  const [cartId] = useState(getCartId);
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("bmi_cart") || "[]"));
  const [priced, setPriced] = useState({ items: [], subtotal: 0, mrp_total: 0, discount: 0, total: 0 });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("bmi_cart", JSON.stringify(items));
    api.put(`/cart/${cartId}`, { items }).then((r) => setPriced(r.data)).catch(() => {});
  }, [items, cartId]);

  const add = useCallback((product_id, sku, qty = 1) => {
    setItems((cur) => {
      const ex = cur.find((i) => i.sku === sku);
      if (ex) return cur.map((i) => (i.sku === sku ? { ...i, qty: Math.min(20, i.qty + qty) } : i));
      return [...cur, { product_id, sku, qty }];
    });
  }, []);
  const setQty = (sku, qty) => setItems((cur) => cur.map((i) => (i.sku === sku ? { ...i, qty: Math.max(1, Math.min(20, qty)) } : i)));
  const remove = (sku) => setItems((cur) => cur.filter((i) => i.sku !== sku));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartCtx.Provider value={{ cartId, items, priced, add, setQty, remove, clear, count, open, setOpen }}>{children}</CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
